import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { EnvService } from "gematik-form-library";
import { HttpConfig } from "../http-config";

export interface ITemplate {
  name: string;
  content: string;
}

@Injectable({
  providedIn: "root",
})
export class TemplateService {
  constructor(private http: HttpClient, private env: EnvService) {}

  getAll(): Observable<ITemplate[]> {
    return this.http.get<ITemplate[]>(this.env.notificationsBackendUrl + "/templates");
  }

  create(template: ITemplate): Observable<ITemplate> {
    return this.http.post<ITemplate>(this.env.notificationsBackendUrl + "/templates", template);
  }

  update(template: ITemplate): Observable<ITemplate> {
    return this.http.put<ITemplate>(
      `${this.env.notificationsBackendUrl}/templates/${template.name}`,
      template,
    );
  }

  delete(template: ITemplate): Observable<ITemplate> {
    return this.http.delete<ITemplate>(
      `${this.env.notificationsBackendUrl}/templates/${template.name}`,
    );
  }

  downloadTemplate(templateName: string): Observable<Blob> {
    return this.http.get(`${this.env.notificationsBackendUrl}/templates/download/${templateName}`, {
      responseType: "blob",
    });
  }

  uploadTemplate(file: File): Observable<ITemplate> {
    const data: FormData = new FormData();
    data.append("file", file);
    return this.http.post<ITemplate>(this.env.notificationsBackendUrl + "/templates/upload", data);
  }
}
